import {
  SIGN_IN_LOADING_STATUS,
  SIGN_UP_LOADING_STATUS,
  GET_CLUBS_LOADING_STATUS,
  GET_ALL_TEAMS_LOADING_STATUS,
} from 'constants/actionTypes';

export const getState = (store = {}) => store;
export const getAuth = store => getState(store).auth;
export const getSignInLoadingStatus = store => getAuth(store)[SIGN_IN_LOADING_STATUS];
export const getSignUpLoadingStatus = store => getAuth(store)[SIGN_UP_LOADING_STATUS];
export const getPopup = store => getState(store).popup;
export const getToaster = store => getState(store).toaster;
export const getDialog = store => getState(store).dialog;
export const getUser = store => getAuth(store).user;
export const getUserName = store => getUser(store).username;
export const getUserToken = store => getUser(store).token;
export const getTeams = store => getState(store).teams.data;
export const getAllTeamsInfo = store => getState(store).teams.info;
export const getAllTeamsLoadingStatus = store =>
  getState(store).teams[GET_ALL_TEAMS_LOADING_STATUS];
export const getTeamInfo = (store, id) => getAllTeamsInfo(store)[id] || {};
export const getTeamInfoOwnerAccount = (store, id) => getTeamInfo(store, id).ownerAccount;
export const getTeamInfoPlayerAccount = (store, id) =>
  getTeamInfo(store, id).playerAccount;
export const getUserAvatar = store => getUser(store).personalInfo?.avatar?.imagePath;
export const getTeamPlayers = (store, id) => getTeamInfo(store, id)?.teamPlayers || [];
export const getTeamAvatar = (store, id) =>
  getTeamInfo(store, id).teamInfo?.personalInfo?.avatar?.imagePath;
export const getTeamHeaderImage = (store, id) =>
  getTeamInfo(store, id).teamInfo?.personalInfo?.headerImage?.imagePath;
export const getTeamSubTitle = (store, id) => getTeamInfo(store, id).teamInfo?.subTitle;
export const getClubs = store => getState(store).clubs.data;
export const getClubsLoadingStatus = store =>
  getState(store).clubs[GET_CLUBS_LOADING_STATUS];
export const getTournamentsList = store => getState(store).leaderboard.tournamentsList;
export const getTeamLeaderBoard = store => getState(store).leaderboard.teamLeaderBoard;
export const getPlayerLeaderBoard = store =>
  getState(store).leaderboard.playerLeaderBoard;
export const getAvatars = store => getState(store).avatars;
export const getLiveMatches = store => getState(store).matches.liveMatches;
export const getUpcomingMatches = store => getState(store).matches.upcomingMatches;
export const getArchivedMatches = store => getState(store).matches.archivedMatches;
export const getMatchPlayers = store => getState(store).matches.players;
export const getMatchSessions = store => getState(store).matches.sessions;
export const getSessionSeatDraw = store => getState(store).matches.seatDraw;
export const getPlayersPublicInfo = store => getState(store).matches.playersPublicInfo;
